import React, { memo, SVGProps } from 'react'

export const Sort = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5254 17.04H4.32001C3.92257 17.04 3.60001 17.3626 3.60001 17.76C3.60001 18.1574 3.92257 18.48 4.32001 18.48H16.5254C16.9229 18.48 17.2454 18.1574 17.2454 17.76C17.2454 17.3626 16.9229 17.04 16.5254 17.04Z"
      fill="currentColor"
    />
    <path
      d="M19.68 5.52H4.32001C3.92257 5.52 3.60001 5.84256 3.60001 6.24C3.60001 6.63744 3.92257 6.96 4.32001 6.96H19.68C20.0774 6.96 20.4 6.63744 20.4 6.24C20.4 5.84256 20.0774 5.52 19.68 5.52Z"
      fill="currentColor"
    />
    <path
      d="M4.32001 12.72H11.7254C12.1229 12.72 12.4454 12.3974 12.4454 12C12.4454 11.6026 12.1229 11.28 11.7254 11.28H4.32001C3.92257 11.28 3.60001 11.6026 3.60001 12C3.60001 12.3974 3.92257 12.72 4.32001 12.72Z"
      fill="currentColor"
    />
  </svg>
))
